import { render, staticRenderFns } from "./sectionTwo.vue?vue&type=template&id=2f666af2&scoped=true&"
import script from "./sectionTwo.vue?vue&type=script&lang=js&"
export * from "./sectionTwo.vue?vue&type=script&lang=js&"
import style0 from "./sectionTwo.vue?vue&type=style&index=0&id=2f666af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f666af2",
  null
  
)

export default component.exports